import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  return data?.data?.value ?? defaultSoundSdk
}

export const getNotifConfig = (tokens: any) => {
  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: APIEndPoints.getConfigList,
    body: getConfigRequest(),
    method: 'POST',
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

const getConfigRequest = () => {
  return {
    key: 'AUDIO_PROVIDER',
  }
}

export const defaultSoundSdk = 'JIO_TTS'
